/**
 * Sub-delegate invite API — Feature 075.
 * Three calls mirroring the Care-Seeker invite API shape.
 */

import { apiClient } from '@/core/api/client';
import type {
  AcceptAdditionalSubDelegateInviteResponse,
  AcceptSubDelegateInvitePayload,
  AcceptSubDelegateInviteResponse,
  SubDelegateInvitePublicResponse,
} from '../types/subDelegateInvite';

export const validateSubDelegateInvite = async (
  token: string,
): Promise<SubDelegateInvitePublicResponse> => {
  const response = await apiClient.get<SubDelegateInvitePublicResponse>(
    `/workspace/sub-delegates/invite/${token}`,
  );
  return response.data;
};

export const acceptSubDelegateInvite = async (
  token: string,
  payload: AcceptSubDelegateInvitePayload,
): Promise<AcceptSubDelegateInviteResponse> => {
  const response = await apiClient.post<AcceptSubDelegateInviteResponse>(
    `/workspace/sub-delegates/invite/${token}/accept`,
    payload,
  );
  return response.data;
};

export const acceptAdditionalSubDelegateInvite = async (
  token: string,
): Promise<AcceptAdditionalSubDelegateInviteResponse> => {
  const response =
    await apiClient.post<AcceptAdditionalSubDelegateInviteResponse>(
      `/workspace/sub-delegates/invite/${token}/accept-additional`,
    );
  return response.data;
};
